let commonComponents = [];